<script lang="ts">
  /**
   * Un nombre qu'on monte, qu'on descend ou qu'on écrit, borné des deux côtés.
   *
   * Les boutons avancent d'un `pas` réglable : monter une Compétence de 15 à 30
   * demande quinze clics au pas de 1, et trois au pas de 5. Le champ, lui,
   * accepte la valeur directement — c'est le chemin le plus court quand on sait
   * déjà où l'on va.
   */
  import NombreSaisi from './NombreSaisi.svelte'

  let {
    valeur,
    min = 0,
    max = Infinity,
    libelle,
    pas = 1,
    onchange,
  }: {
    valeur: number
    min?: number
    /** Omis quand rien ne borne par le haut — l'XP gagné, par exemple. */
    max?: number
    libelle: string
    pas?: number
    onchange: (v: number) => void
  } = $props()

  const auPlafond = $derived(valeur >= max)
  const auPlancher = $derived(valeur <= min)

  const poser = (v: number) => onchange(Math.min(max, Math.max(min, v)))
</script>

<div class="compteur">
  <button
    type="button"
    onclick={() => poser(valeur - pas)}
    disabled={auPlancher}
    aria-label="Retirer {pas} à {libelle}">−</button
  >
  <NombreSaisi valeur={valeur} {min} {max} {libelle} {pas} onchange={poser} />
  <button
    type="button"
    onclick={() => poser(valeur + pas)}
    disabled={auPlafond}
    aria-label="Ajouter {pas} à {libelle}">+</button
  >
</div>

<style>
  .compteur {
    display: inline-flex;
    align-items: center;
    gap: var(--pas);
  }
  button {
    width: 2.75rem;
    height: 2.5rem;
    border: 1px solid var(--line-fort);
    background: var(--surface-2);
    color: var(--ink);
    border-radius: var(--r);
    font-size: 1.1rem;
    line-height: 1;
    cursor: pointer;
  }
  button:hover:not(:disabled) {
    border-color: var(--gold);
    color: var(--gold);
  }
  button:disabled {
    opacity: 0.35;
    cursor: default;
  }
</style>
